import React from 'react';

import SectionContainer from 'components/sectionContainer';
import HighlightedText from 'components/highlightedText';
import { Title } from 'components/typography';
import { ROADMAP } from './RoadMap.constants';

import {
  roadMapSection,
  roadMapContent,
  roadMapSectionIntro,
  roadMapTitle,
  roadMap,
  title,
} from './scss/RoadMap.module.scss';

const RoadMap = () => {
  return (
    <SectionContainer className={roadMapSection}>
      <div className={roadMapSectionIntro}>
        <Title
          className={roadMapTitle}
          size="xl"
          value={
            <span>
              {'The'}
              <HighlightedText value="Xpert" />
              {' Formula '}
            </span>
          }
        />
        <p>
          Our not-so-secret process for building products that are <br />
          transforming the commodities ecosystem.
        </p>
      </div>

      <div className={roadMapContent}>
        {ROADMAP.map((item, index) => (
          <div key={`main-${index}`} className={roadMap}>
            <img src={item.image} alt={item.title} />
            <p className={title}>
              <span>{`0${index + 1}. `}</span>
              {item.title}
            </p>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </SectionContainer>
  );
};

export default RoadMap;
